import { createContext, useContext } from "react";

import { useCompanyObject } from "../company/useCompanyObject";

const DefaultRangeSetIdContext = createContext<string | null>(null);

export const DefaultRangeSetIdScopeProvider = ({
  children,
  rangeSetId,
}: {
  children: React.ReactNode;
  rangeSetId: string | null;
}) => {
  return (
    <DefaultRangeSetIdContext.Provider value={rangeSetId}>
      {children}
    </DefaultRangeSetIdContext.Provider>
  );
};

export const ActiveRangeSetIdScopeProvider = ({ children }: { children: React.ReactNode }) => {
  const company = useCompanyObject();
  const { activeRangeSetId } = company || { activeRangeSetId: null };
  return (
    <DefaultRangeSetIdScopeProvider rangeSetId={activeRangeSetId}>
      {children}
    </DefaultRangeSetIdScopeProvider>
  );
};

export function useDefaultRangeSetIdScope() {
  const rangeSetId = useContext(DefaultRangeSetIdContext);
  return rangeSetId;
}
